import dayjs from 'dayjs';

// Mirrors Audits::LogQuery: every query is bounded in time.
export const DEFAULT_DAYS = 30;
export const MAX_DAYS = 366;

const fmt = (d) => d.format('YYYY-MM-DD');

// The range to show and query: the URL's dates, else the last 30 days. A lone
// `to` gets the 30 days before it; a lone `from` runs to today.
export const resolveRange = (from, to, today = dayjs()) => {
  const end = to || fmt(today);
  const start = from || fmt(dayjs(end).subtract(DEFAULT_DAYS - 1, 'day'));
  return { from: start, to: end };
};

// null when the range is fine, else the reason it is refused.
export const rangeError = (from, to) => {
  if (!from || !to) return null;
  const days = dayjs(to).diff(dayjs(from), 'day') + 1;
  if (days < 1) return 'The start date must be on or before the end date.';
  if (days > MAX_DAYS) return `Pick at most ${MAX_DAYS} days — export narrower ranges for older events.`;
  return null;
};
